import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';

import BootstrapModal from '../../../../../shared-components/modal/bootstrap-modal';
import { ArrowBack } from '../../../../../shared-components/icons';

import { FlagReasonFlow } from './flag-reason-flow';
import { FlagCategoryFlow } from './flag-category-flow';
import { FlagDetailsFlow } from './flag-detials-flow';
import { useFlagMessageContext } from './utils/utils';

const FlagMessageModal = ({ intl }) => {
  const {
    setShowModal,
    showModal,
    currentStep,
    goBack
  } = useFlagMessageContext();

  const close = useCallback(() => {
    setShowModal(false);
  }, [showModal]);

  const title = useMemo(() => {
    const isFirstStep = 'reason' === currentStep;

    const message = isFirstStep
      ? <FormattedMessage
        id="stream.flag_message.why_reporting"
        defaultMessage="Why are you reporting this?"
      />
      : <FormattedMessage
        id="stream.flag_message.provide_details"
        defaultMessage="Please provide more details"
      />;

    return <div>
      {!isFirstStep && <button className="go-back-button" type="button" onClick={goBack}><ArrowBack /></button>}
      <h3 className={classNames('flag-message-modal-title', { 'with-back-button': !isFirstStep })}>
        {message}
      </h3>
    </div>;
  }, [currentStep, intl.locale]);

  const BodyComponent = 'reason' === currentStep
    ? FlagReasonFlow
    : 'category' === currentStep
      ? FlagCategoryFlow
      : 'details' === currentStep
        ? FlagDetailsFlow : React.Fragment;

  return (
    <BootstrapModal
      showModal={showModal}
      modalClass="flag-message-modal"
      onClose={close}
      addCloseIcon
      title={title}
      body={<BodyComponent />}
    />
  );
};

FlagMessageModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  handleFlagMessage: PropTypes.func,
  intl: intlShape
};

exports.FlagMessageModal = injectIntl(FlagMessageModal);
